export enum Tab {
  Encounters = "Encounters",
  Submit = "Submit",
  Member = "Member",
  DxReview = "dx-review",
}
